<template>
    <div>
        <div v-if="loading" class="text-center" style="margin-top: 10em">
            <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <div v-else>
            <transition appear name="slide-fade">
                <div>
                    <button_back></button_back>
                    <h3 class="text-orange mt-3">{{ title }}</h3>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card" style="min-height: 500px">
                                <div class="card-header"></div>
                                <div class="card-body">
                                    <table class="table table-bordered table-condensed table-hover my_table_1 w-50 mx-auto">
                                        <thead>
                                            <tr>
                                                <th style="width: 5%" class="text-center">#</th>
                                                <th style="width: 40%">Nombre</th>
                                                <th style="width: 25%" class="text-center">Fecha Actualización</th>
                                                <th class="text-center" style="width: 20%">
                                                    Posición
                                                </th>
                                                <th class="text-center" style="width: 10%">
                                                    opciones
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(top_aliado, index_aliado) in top_aliados" v-bind:key="index_aliado">
                                                <td class="text-center">
                                                    {{ top_aliado.num }}
                                                </td>
                                                <td>
                                                    {{ top_aliado.aliado.nombre_aliado }}
                                                </td>
                                                <td class="text-center">
                                                    {{ top_aliado.fecha_actualizacion }}
                                                </td>
                                                <td class="text-center">
                                                    {{ top_aliado.posicion }}
                                                </td>
                                                <td class="text-center">
                                                    <div class="dropdown">
                                                        <a class="btn btn-outline-primary btn-sm rounded-pill"
                                                            href="javascript:void(0)" role="button" v-on:click="
                                                                show_modal(index_aliado)
                                                            ">
                                                            Editar
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <modal name="modal_editar" :adaptive="true" height="280">
            <div class="card m-4">
                <div class="card-header">
                    <h4 class="fw-bold text-orange">Top Aliado</h4>
                </div>
                <div class="card-body">
                    <div v-if="index_select != null">
                        <div class="form-group">
                            <label>Buscar</label>
                            <v-select v-model="aliado" @search="get_aliados" @input="select_aliado" label="nombre_aliado"
                                :options="aliados"></v-select>
                        </div>
                    </div>
                    <hr />
                    <div class="text-end">
                        <button @click="actualizar_top()" class="btn btn-outline-secondary rounded-pill">
                            Actualizar posición
                        </button>
                        <button @click="$modal.hide('modal_editar')" class="btn btn-outline-secondary rounded-pill">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import "vue-select/dist/vue-select.css";
import { defineAsyncComponent } from 'vue';
import axios from "axios";
export default {
    name: 'Top_5_aliados',
    components: {
        button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
    },
    data() {
        return {
            loading: true,
            title: null,
            top_aliados: [],
            aliados: [],
            aliado: null,
            index_select: null,
        };
    },
    created: function () {
        this.getTitle();
        this.get_top_aliados();
        this.get_aliados();
    },
    props: {
        session: Object,
    },
    methods: {
        getTitle() {
            this.title = 'Top 5 aliados'
            this.loading = false
        },
        get_top_aliados() {
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                },
            };
            axios
                .get(this.$base_url + "aliados/top_aliados", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.top_aliados = response.data.data.top_aliados;

                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        show_modal: function (index) {
            this.index_select = index;
            this.$modal.show("modal_editar");
        },
        get_aliados() {
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                    'estado': 2
                },
            };
            axios
                .get(this.$base_url + "aliados/aliados", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.aliados = response.data.data.aliados;

                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        select_aliado() {
            console.log(this.aliado);
        },
        actualizar_top() {
            console.log(this.aliado);
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                    'id': this.top_aliados[this.index_select].id,
                    'id_aliado': this.aliado.id_aliado
                },
            };
            axios
                .post(this.$base_url + "aliados/actualizar_top", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.get_top_aliados()
                    this.$modal.hide("modal_editar");
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        }
    }
}
</script>